import { useTranslation } from "react-i18next";
import { NeuDropdown } from "../../components/data/NeuDropdown";
import { Field, ReadOnly, Section } from "./ItemFormParts";
import { localName } from "../../lib/localName";

// التصنيف المحاسبي: النوع → التصنيف (يملأ حسابي الأصول والمصروفات ومركز التكلفة تلقائياً).
export const ItemSectionAccounting = ({ form, setForm, meta }) => {
  const { t, i18n } = useTranslation();
  const ar = i18n.language === "ar";
  const type = meta.types.find((row) => row.key === form.item_type);
  const categories = meta.categories.filter((row) => row.item_type === form.item_type);
  const category = meta.categories.find((row) => row.key === form.accounting_category);

  const pickCategory = (key) => {
    const cat = meta.categories.find((row) => row.key === key);
    const center = meta.centers.find((row) => row.code === cat?.cost_center_code);
    setForm({ ...form, accounting_category: key, asset_account_code: cat?.asset_account || "",
              expense_account_code: cat?.expense_account || "", pricing_mode: cat?.pricing_mode || "fixed",
              default_cost_center_id: form.default_cost_center_id || center?.id || "" });
  };

  return (
    <Section testid="item-section-accounting" title={t("purchases.items.category")}>
      <Field label={t("purchases.items.type")} required hint={ar ? type?.hint_ar : type?.name_en}>
        <NeuDropdown testid="item-type" value={form.item_type}
                     onChange={(value) => setForm({ ...form, item_type: value, accounting_category: "",
                                                    asset_account_code: "", expense_account_code: "" })}
                     options={meta.types.map((row) => ({ value: row.key, label: localName(row) }))} />
      </Field>
      <Field label={t("purchases.items.category")} required
             hint={category ? `${t("purchases.items.codePrefix")}: ${category.prefix}-#####` : null}>
        <NeuDropdown testid="item-category" value={form.accounting_category}
                     placeholder={t("purchases.items.pickCategory")} onChange={pickCategory}
                     options={categories.map((row) => ({ value: row.key, label: localName(row) }))} />
      </Field>
      <Field label={t("purchases.items.assetAccount")}>
        <ReadOnly testid="item-asset_account_code" value={form.asset_account_code}
                  placeholder={t("purchases.items.accountFromCategory")} />
      </Field>
      <Field label={t("purchases.items.expenseAccount")}>
        <ReadOnly testid="item-expense_account_code" value={form.expense_account_code}
                  placeholder={t("purchases.items.accountFromCategory")} />
      </Field>
      <p className="text-[11px] text-muted-foreground sm:col-span-2">💡 {t("purchases.items.accountsAutoHint")}</p>
    </Section>
  );
};
